import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
} from "react-bootstrap";
import { logout } from "../actions/userActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { getRestaurantSubscription } from "../actions/userActions";
import LogoImage from "../icons/logo.png";

import {
  fetchRestaurantList,
  fetchRestaurantDetails,
} from "../actions/restaurantActions";

import { getManager } from "../actions/managersActions";
import SuspensionAccountWarning from "./SuspensionAccountWarning";
import { faLock } from "@fortawesome/free-solid-svg-icons";

import { Link } from "react-router-dom";
import styled from "styled-components";
import {
  faSignOut,
  faBars,
  faUtensils,
  faCircleInfo,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faChevronDown,
} from "@fortawesome/free-solid-svg-icons";

import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  CalendarSvgIcon,
  FilterSvgIcon,
  GearSvgIcon,
  NoPhoneSvgIcon,
  OnOffSvgIcon,
  PhoneSvgIcon,
  PlusSvgIcon,
  ReservationSvgIcon,
  TableSvgIcon,
  UsersSvgIcon,
  XSvgIcon,
  UserSvgIcon,
  ClockSvgIcon,
  BellSvgIcon,
  BubbleTextSvgIcon,
  ZoneSvgIcon,
  RestaurantIconSvg,
  InfoIconSvg,
} from "../icons/SvgIcons";
import { colors } from "@mui/material";
import SwitchOnAndOff from "./SwitchOnAndOff";
import { ConfirmationModal } from "./ConfirmationModal";

// Sidebar for large screens / Top header for small screens

// ✅ Use transient props ($isCollapsed) so they don't reach the DOM
const Sidebar = styled.aside`
  position: relative;
  top: 0;
  left: 0;
  height: 100vh;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "60px" : "300px")};
  background-color: #faf6e9;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  justify-content: space-between;
  transition: width 0.3s ease;

  @media (min-width: 769px) {
    overflow: visible;
  }

  @media (max-width: 768px) {
    position: fixed;
    height: 60px;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 1rem;
    overflow: visible;
  }
`;

const HeaderTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 100px;
  margin-top: 50px;
  font-size: 2rem;
  color: #ff5733;
  font-weight: bold;

  @media (max-width: 768px) {
    width: 50px;
    height: 30px;
    margin-top: 0;
    margin-left: 20px;
  }
`;

// ✅ transient props: $isCollapsed / $isOpen
const StyledDropdownButton = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  border: 1px solid ${({ $isOpen }) => ($isOpen ? "#ee754c" : "transparent")};
  border-radius: 8px;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "55px" : "190px")};
  height: ${({ $isCollapsed }) => ($isCollapsed ? "35px" : "auto")};
  padding: 5px;
  gap: ${({ $isCollapsed }) => ($isCollapsed ? "0" : "10px")};
  cursor: pointer;
  font-size: 1.2rem;
  font-weight: 500;
  color: ${({ $isOpen }) => ($isOpen ? "#ee754c" : "#4b3335")};
  margin-left: ${({ $isCollapsed }) => ($isCollapsed ? "2px" : "-8px")};
  margin-bottom: 0.5rem;
  box-sizing: border-box;
  transition: all 0.2s ease;

  svg {
    stroke: ${({ $isOpen }) => ($isOpen ? "#ee754c" : "#4b3335")};
    min-width: 28px;
  }

  ${({ $isCollapsed }) =>
    $isCollapsed &&
    `
    padding-left: 0;
    padding-right: 0;
  `}

  @media (max-width: 768px) {
    margin-left: 0px;
  }
`;

const Logo = styled.img`
  height: 80px;
  margin-right: 10px;

  @media (max-width: 768px) {
    height: 50px;
    margin-right: 5px;
  }
`;

// ✅ transient prop
const Menu = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  justify-content: center;
  gap: 1px;
  padding-left: ${({ $isCollapsed }) => ($isCollapsed ? "0" : "1.5rem")};
  padding-top: 1rem;
  padding-bottom: 1rem;
  flex: 1;
  width: 100%;

  @media (max-width: 768px) {
    justify-content: flex-start;
    margin-top: 0;
  }
`;

const RestaurantName = styled.nav`
  color: #4b3335;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: 500;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 1px;
  width: auto;
  gap: 10px;
  color: #ee754c;

  &.active {
    border-color: #ee754c;
    color: #ee754c;
    font-weight: bold;

    svg {
      stroke: #ee754c !important;
    }
  }

  &:hover {
    color: #ee754c;

    svg {
      stroke: #ee754c;
    }
  }
  @media (max-width: 768px) {
    margin-right: 20px;
  }
`;

const ShowBigScreen = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  @media (max-width: 768px) {
    display: none;
  }
`;

// ✅ IMPORTANT: styled(NavLink) → ultimately <a>. Use $isCollapsed so it won't forward.
const MenuLink = styled(NavLink)`
  color: #4b3335;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: 500;
  display: flex;
  align-items: center;

  border: 1px solid transparent;
  border-radius: 8px;
  padding: 5px;
  width: ${({ $isCollapsed }) => ($isCollapsed ? "55px" : "190px")};
  gap: ${({ $isCollapsed }) => ($isCollapsed ? "0" : "10px")};
  justify-content: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  transition: all 0.3s ease;
  margin-left: 2px;

  &.active {
    border-color: #ee754c;
    color: #ee754c;
    font-weight: bold;

    svg {
      stroke: #ee754c !important;
    }
  }

  &:hover {
    color: #ee754c;
    border-color: #ee754c;

    svg {
      stroke: #ee754c;
    }
  }
`;

// ✅ transient prop
const Footer = styled.div`
  padding: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: ${({ $isCollapsed }) =>
    $isCollapsed ? "center" : "flex-start"};
  gap: 0.8rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const StyledButton = styled(Button)`
  background-color: #ff751a;
  border: none;
  font-size: 1rem;
  color: white;

  &:hover {
    background-color: #e64a00;
  }
`;

const MobileMenuButton = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    cursor: pointer;
    font-size: 1.5rem;
    color: #ff5733;
  }
`;

// ✅ transient prop
const MobileMenuContainer = styled.div`
  display: ${({ $show }) => ($show ? "flex" : "none")};
  flex-direction: column;
  background-color: #faf6e9;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  padding: 1rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

  @media (min-width: 768px) {
    display: none;
  }
`;

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff751a;
  border-radius: 50%;
  width: 50px;
  height: 50px;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  min-width: 28px;
`;

// ✅ transient prop and actually pass it in JSX
const CollapseToggleButton = styled(Button)`
  position: absolute;
  top: 10px;
  right: ${({ $isCollapsed }) => ($isCollapsed ? "12px" : "16px")};
  z-index: 1500;
  padding: 0.3rem 0.5rem;
  font-size: 1rem;
  color: #ee754c;

  @media (max-width: 768px) {
    display: none;
  }
`;

const DropdownWrapper = styled.div`
  position: relative;
  margin-left: 40px;
  margin-top: 50px;
  width: 200px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 160px;
    min-width: 120px;
    margin: 0;
    margin-right: 30px;
  }
`;

const DropdownButton = styled.button`
  width: 100%;
  padding: 8px 12px;
  font-size: 0.8rem;
  font-weight: bold;
  color: #ee754c;
  background-color: #faf6e9;
  border: 2px solid #ee754c;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(238, 116, 76, 0.4);
  }
`;

const DropdownList = styled.ul`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 0.5rem 0;
  margin: 0;
  list-style: none;
  z-index: 1000;
  max-height: 250px;
  overflow-y: auto;
`;

const DropdownItem = styled.li`
  padding: 10px 16px;
  font-size: 0.85rem;
  color: #99b0ad;
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    background-color: #fff1e9;
    color: #ee754c;
  }

  &.active {
    font-weight: bold;
    color: #ee754c;
  }
`;

const RestaurantMenuLinks = ({
  restaurant_id,
  restaurants,
  list_of_restaurants,
  dispatch,
  managerInfo,
  setShowMenu,
  userInfo,
  setShowModal = false,
  isCollapsed = false,
}) => {
  const [activeLink, setActiveLink] = useState("");

  const handleLinkClick = (link) => {
    setActiveLink(link);
    setShowMenu(false);
  };

  const getLinkStyles = (link, condition) => ({
    pointerEvents: condition ? "none" : "auto",
    cursor: condition ? "default" : "pointer",
    border: activeLink === link ? "1px solid #EE754C" : "1px solid transparent",
    color: activeLink === link ? "#EE754C" : "#4B3335",
  });

  const LockIcon = ({ condition }) =>
    condition ? (
      <FontAwesomeIcon
        icon={faLock}
        style={{ color: "#858585", marginLeft: "20px" }}
      />
    ) : null;

  const RenderMenuRow = ({
    linkKey,
    to,
    label,
    Icon,
    disabled = false,
    lock = false,
  }) => (
    <div
      onClick={() => handleLinkClick(linkKey)}
      style={{ marginBottom: "0.5rem" }}
    >
      <MenuLink
        to={to}
        style={getLinkStyles(linkKey, disabled)}
        $isCollapsed={isCollapsed} // ✅ fixed
        onClick={(e) => {
          if (linkKey === "sair") {
            e.preventDefault();
            setShowModal(true);
          } else {
            handleLinkClick(linkKey);
          }
        }}
      >
        <IconWrapper>
          <Icon
            width={isCollapsed ? 22 : 25}
            height={20}
            strokeColor={activeLink === linkKey ? "#EE754C" : "#4B3335"}
          />
        </IconWrapper>
        {!isCollapsed && (
          <>
            <span>{label}</span>
            {lock && (
              <FontAwesomeIcon
                icon={faLock}
                style={{ color: "#858585", marginLeft: "auto" }}
              />
            )}
          </>
        )}
      </MenuLink>
    </div>
  );

  return (
    <div style={{ textAlign: "start", width: "100%" }}>
      <>
        {list_of_restaurants && (
          <div
            style={{ paddingLeft: isCollapsed ? 0 : "0.5rem", width: "100%" }}
          >
            <div style={{ marginBottom: "0.5rem" }}>
              <RestaurantSelectDropdown
                restaurants={list_of_restaurants}
                selectedId={restaurant_id}
                onChange={(id) => dispatch(fetchRestaurantDetails(id))}
                isCollapsed={isCollapsed}
              />
            </div>
          </div>
        )}

        {!managerInfo && (
          <RenderMenuRow
            linkKey="colaboradores"
            to="/manager_account_creation"
            label="Membros"
            Icon={UsersSvgIcon}
          />
        )}

        {restaurant_id && (
          <>
            <RenderMenuRow
              linkKey="reservas"
              to={`reservationfromrestaurant/${restaurant_id}/null/filter`}
              label="Reservas"
              Icon={ReservationSvgIcon}
            />

            <RenderMenuRow
              linkKey="horarios"
              to={`/time/${restaurant_id}`}
              label="Horários"
              Icon={ClockSvgIcon}
              disabled={managerInfo && !managerInfo.edit_closed_days}
              lock={managerInfo && !managerInfo?.edit_closed_days}
            />

            <>
              <RenderMenuRow
                linkKey="Não mexer"
                to={`/place_design/${restaurant_id}`}
                label="Salas e mesas"
                Icon={ZoneSvgIcon}
                disabled={managerInfo && !managerInfo.edit_restaurant_settings}
                lock={managerInfo && !managerInfo.edit_restaurant_settings}
              />
            </>

            <RenderMenuRow
              linkKey="clientes"
              to={`/restaurantclients/${restaurant_id}`}
              label="Clientes"
              Icon={UsersSvgIcon}
              disabled={managerInfo && !managerInfo.edit_restaurant_settings}
              lock={managerInfo && !managerInfo.edit_restaurant_settings}
            />

            <RenderMenuRow
              linkKey="notificacoes"
              to={`/restaurant_notifications/${restaurant_id}`}
              label="Notificações"
              Icon={BellSvgIcon}
              disabled={managerInfo && !managerInfo.edit_restaurant_settings}
              lock={managerInfo && !managerInfo.edit_restaurant_settings}
            />

            <RenderMenuRow
              linkKey="definicoes"
              to={`/restaurantsettingsupdate/${restaurant_id}`}
              label="Definições"
              Icon={GearSvgIcon}
              disabled={managerInfo && !managerInfo.edit_restaurant_settings}
              lock={managerInfo && !managerInfo.edit_restaurant_settings}
            />

            <RenderMenuRow
              linkKey="info"
              to={`/restaurant_info_update/${restaurant_id}`}
              label="Informações"
              Icon={InfoIconSvg}
              disabled={managerInfo && !managerInfo.edit_restaurant_settings}
              lock={managerInfo && !managerInfo.edit_restaurant_settings}
            />

            {setShowModal && (
              <>
                <RenderMenuRow
                  linkKey="conta"
                  to="/profile/update/no"
                  label="Conta"
                  Icon={UserSvgIcon}
                />

                <RenderMenuRow
                  linkKey="sair"
                  to="#"
                  label="Sair"
                  Icon={OnOffSvgIcon}
                  disabled={false}
                  lock={false}
                />
              </>
            )}
          </>
        )}
      </>
    </div>
  );
};

const RestaurantSelectDropdown = ({
  restaurants = [],
  selectedId,
  onChange,
  isCollapsed,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const selectedRestaurant = restaurants.find((r) => r.id === selectedId) || {};

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleSelect = (id) => {
    onChange(id);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div style={{ position: "relative", width: "100%" }} ref={wrapperRef}>
      <StyledDropdownButton
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
        $isCollapsed={isCollapsed} // ✅ fixed
        $isOpen={isOpen} // ✅ fixed
      >
        <IconWrapper>
          <RestaurantIconSvg
            width={isCollapsed ? 22 : 25}
            height={20}
            strokeColor={isOpen ? "#ee754c" : "#4B3335"}
          />
        </IconWrapper>

        {!isCollapsed && (
          <>
            <span
              style={{
                display: "inline-block",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {selectedRestaurant.restaurant_name?.length > 11
                ? selectedRestaurant.restaurant_name.substring(0, 11) + "..."
                : selectedRestaurant.restaurant_name ||
                  "Selecionar restaurante"}
            </span>
            <FontAwesomeIcon
              icon={isOpen ? faChevronUp : faChevronDown}
              style={{ marginLeft: "-9px" }}
            />
          </>
        )}
      </StyledDropdownButton>

      {isOpen && (
        <DropdownList
          style={{
            left: isCollapsed ? "62px" : "-11px",
            top: isCollapsed ? "0" : "calc(100% + 6px)",
            width: "200px",
            zIndex: 1000,
          }}
        >
          <DropdownItem
            key="go-to-home"
            onClick={() => {
              setIsOpen(false);
              window.location.href = "/";
            }}
            style={{ color: "#99b0ad", fontWeight: "bold" }}
          >
            Restaurantes
          </DropdownItem>

          {restaurants.map((r) => (
            <DropdownItem
              key={r.id}
              onClick={() => {
                onChange(r.id);
                setIsOpen(false);
              }}
              className={r.id === selectedId ? "active" : ""}
            >
              {r.restaurant_name}
            </DropdownItem>
          ))}
        </DropdownList>
      )}
    </div>
  );
};

function Header({}) {
  const [showMenu, setShowMenu] = useState(false);
  const toggleMenu = () => setShowMenu(!showMenu);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [showHeader, setShowHeader] = useState(true);
  const [restaurant_id, setRestaurant_id] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const manager_info = useSelector((state) => state.crudManager);
  const { managerInfo } = manager_info;

  const restaurant_sub = useSelector((state) => state.restaurant_subscription);
  const { restaurantSubscription } = restaurant_sub;

  const restaurantList = useSelector((state) => state.restaurantList);
  const { restaurants: list_of_restaurants, isLoading, error } = restaurantList;

  const restaurantDetails = useSelector((state) => state.restaurantDetails);
  const { restaurants } = restaurantDetails;

  const create_a_restaurant = useSelector((state) => state.create_a_restaurant);
  const { createRestaurant } = create_a_restaurant;

  const hash = window.location.hash;

  useEffect(() => {
    dispatch(fetchRestaurantList());
  }, [dispatch, userInfo, createRestaurant]);

  useEffect(() => {
    if (
      restaurantSubscription &&
      restaurantSubscription[0].account_type === "not_vip"
    ) {
      setShowHeader(false);
    } else {
      setShowHeader(true);
    }
  }, [restaurantSubscription]);

  useEffect(() => {
    dispatch(getRestaurantSubscription());
    dispatch(getManager());
  }, [dispatch]);

  useEffect(() => {
    if (restaurants) {
      setRestaurant_id(restaurants.id);
    } else {
      setRestaurant_id("");
    }
  }, [restaurants]);

  const logoutHandler = (e) => {
    e.preventDefault();
    dispatch(logout(navigate));
    setShowHeader(true);
  };

  useEffect(() => {
    if (
      list_of_restaurants &&
      list_of_restaurants.length > 0 &&
      !restaurant_id
    ) {
      const firstRestaurant = list_of_restaurants[0];
      const selectedId = firstRestaurant.id;

      setRestaurant_id(selectedId);
      dispatch(fetchRestaurantDetails(selectedId));
    }
  }, [dispatch, list_of_restaurants, restaurant_id]);

  useEffect(() => {
    if (createRestaurant) {
      setRestaurant_id(createRestaurant.id);
    }
  }, [createRestaurant]);

  const handleRestaurantChange = (e) => {
    const selectedId = e.target.value;
    dispatch(fetchRestaurantDetails(selectedId));
  };

  return (
    <Sidebar $isCollapsed={isCollapsed}>
      <CollapseToggleButton
        variant="link"
        style={{ color: "#EE754C", fontWeight: "bold" }}
        onClick={() => setIsCollapsed((prev) => !prev)}
        $isCollapsed={isCollapsed} // ✅ fixed + used by styled(Button)
      >
        <FontAwesomeIcon
          style={{ fontSize: "25px" }}
          icon={isCollapsed ? faChevronRight : faChevronLeft}
        />
      </CollapseToggleButton>

      {!isCollapsed && (
        <>
          <HeaderTitle onClick={() => navigate("/")}>
            <Logo src={LogoImage} alt="Logo" style={{ cursor: "pointer" }} />
          </HeaderTitle>
        </>
      )}

      <MobileMenuButton onClick={toggleMenu}>
        <FontAwesomeIcon icon={faBars} />
      </MobileMenuButton>

      <MobileMenuContainer $show={showMenu}>
        <Menu>
          <RestaurantSelectDropdown
            restaurants={list_of_restaurants}
            selectedId={restaurant_id}
            onChange={(id) => dispatch(fetchRestaurantDetails(id))}
            isCollapsed={false}
          />
          <RestaurantMenuLinks
            restaurant_id={restaurant_id}
            restaurants={restaurants}
            managerInfo={managerInfo}
            setShowMenu={setShowMenu}
            userInfo={userInfo}
            setShowModal={setShowModal}
          />
        </Menu>
      </MobileMenuContainer>

      <ShowBigScreen>
        <Menu $isCollapsed={isCollapsed}>
          <RestaurantMenuLinks
            restaurant_id={restaurant_id}
            restaurants={restaurants}
            list_of_restaurants={list_of_restaurants}
            managerInfo={managerInfo}
            setShowMenu={setShowMenu}
            userInfo={userInfo}
            isCollapsed={isCollapsed}
            dispatch={dispatch}
          />
        </Menu>
      </ShowBigScreen>

      <ConfirmationModal
        show={showModal}
        onHide={() => setShowModal(false)}
        onConfirm={logoutHandler}
        title="Sair"
        body="Tens a certeza que queres terminar sessão?"
        confirmLabel="Sair"
        cancelLabel="Cancelar"
        confirmColor="#ee754c"
        cancelColor="#99b0ad"
      />

      {!isCollapsed && (
        <Footer $isCollapsed={isCollapsed}>
          <Link
            to={"/profile/update/no"}
            style={{
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
              color: "#4b3335",
              fontWeight: "500",
            }}
          >
            <Circle style={{ marginRight: "10px" }}>
              <UserSvgIcon strokeColor={"#ffffff"} width={22} height={22} />
            </Circle>
            Conta
          </Link>

          <div
            onClick={() => setShowModal(true)}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "#4b3335",
              fontWeight: "500",
            }}
          >
            <Circle style={{ marginRight: "10px" }}>
              <OnOffSvgIcon strokeColor={"#ffffff"} width={22} height={22} />
            </Circle>
            Sair
          </div>
        </Footer>
      )}

      {isCollapsed && (
        <Footer $isCollapsed={isCollapsed}>
          <Link to={"/profile/update/no"}>
            <Circle>
              <UserSvgIcon strokeColor={"#ffffff"} width={22} height={22} />
            </Circle>
          </Link>

          <div onClick={() => setShowModal(true)} style={{ cursor: "pointer" }}>
            <Circle>
              <OnOffSvgIcon strokeColor={"#ffffff"} width={22} height={22} />
            </Circle>
          </div>
        </Footer>
      )}
    </Sidebar>
  );
}

export default React.memo(Header);
